<template>
  <a-layout class='index animated fadeIn s_bf'>
      <a-form ref="form" :model="search" :style="{ 'marginBottom': '25px' }" :initialValues="search" :onFinish="pageSearchChange" layout="inline">
        <a-form-item label name="keywords">
          <a-input-group compact :style="{ width: '360px' }">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="sn">出库单号</a-select-option>
              <a-select-option value="to">收货人</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="创建日期" name="time">
          <a-range-picker v-model:value="time" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" @change="onChange" />
        </a-form-item>
        <a-form-item >
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='data'  >
        <template v-slot:action="{ record }">
           <a-button type="primary" @click='select(record)' v-if='!checkout'>选择</a-button>
          <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else >{{!record.select ? "选择":"已选择"}}</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
        <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
  </a-layout>

</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
get_out_warehousing_list
} from "@/api/guide";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 8,
  status: "",
  key_type: "sn",
  start_time: "",
  end_time: "",
  keyword: "",
  bonus_status:"1",
  bonus_type: "",
};

export default {
  name:'selectBouns',
  props:{
       selectList:{
        type:Array
      },
      checkout:{
        type:Boolean,
        default:()=>{
            return true
        }
      },
      is_edit:String
  },
  setup(props, {emit}) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      list: [
      ],
      listLoading: false,
      time: [],
      total: 1,
      level: null,
    });
    let columns = [
      {
        title: "出库单号",
        dataIndex: "out_warehousing_sn",
        key: "out_warehousing_sn"
      },
      {
        title: "收货名称",
        dataIndex: "out_warehousing_to_name",
        key: "out_warehousing_to_name"
      },
      {
        title: "发货时间",
        dataIndex: "out_warehousing_time",
        key: "out_warehousing_time",
      },
      {
        title: "出库仓库",
        dataIndex: "author",
        key: "author",
      },
      {
        title: "实际数量",
        dataIndex: "out_warehousing_real_num",
        key: "out_warehousing_real_num",
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        width: 100,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      console.log(state.selectList)
      try {
        let res = await get_out_warehousing_list(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
            if(state.selectList || state.selectList.length > 0){
              data.value.forEach(i=>{
                if( state.selectList.find(v=>{
                  return i.out_warehousing_sn == v.out_warehousing_sn
                })){
                  i.select=true
                }
              })
            }
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      if(props.selectList){
        state.selectList=JSON.parse(JSON.stringify(props.selectList))
      }
      initData(search.value);
    });
         //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        if(e!=0){
        e.select = !e.select
        }
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.vip_id == e.vip_id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        console.log(state.selectList)
        e.select = !e.select
      }
      //多选确认
      const confirm = () =>{  
          emit("select",{
            is_edit:props.is_edit,
            selectList:state.selectList
          });
      }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      confirm,
      checkBnt,
      select
    };
  },
};
</script>